module.exports = __webpack_public_path__ + "807f1f03e5c7f7fca553581aa191bbcb.png";